/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'gm-sidebar-alt',
    templateUrl: './sidebar-alt.component.html',
    styleUrls: ['./sidebar-alt.component.less'],
    standalone: false
})
export class SidebarAltComponent implements OnInit {
  @Input() sidebarOpen: boolean;
  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  currentDate: Date = new Date();

  constructor() { }

  ngOnInit() {
  }

  emitCloseSidebar(){
    this.sidebarOpen = false;
    this.closeSidebar.emit();
  }

}
